module.exports = __webpack_public_path__ + "img/synopsis1.84e614f.svg";